// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XOIMeMLGEzJ7WEYuFR4vDg\\=\\={align-items:center;display:flex;gap:8px}", "",{"version":3,"sources":["webpack://./resources/js/v2/pages/create-app/components/application-form/components/review-submit/components/credit-card-processing/style.module.scss"],"names":[],"mappings":"AAAA,4BAEE,kBAAA,CADA,YAAA,CAEA,OACF","sourcesContent":[".booleanContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"booleanContainer": "XOIMeMLGEzJ7WEYuFR4vDg=="
};
export default ___CSS_LOADER_EXPORT___;
